<template>
    <div style="height: 100%; width: 100%">
        <transition key="1" name="fade" mode="in-out">
            <graph-loader v-show="!renderIsReady"/>
        </transition>
        <div style="height: 100%; width: 100%" id="graph" />
    </div>
</template>
<script>
  import vis from 'vis-network'
  import GraphLoader from "./GraphLoader";

  export default {
    name: "NetworkGraph",
    components: {
      GraphLoader
    },
    props: {
      data: {
        type: Object
      }
    },
    data() {
      return {
        renderIsReady: false
      }
    },
    async mounted() {
      // let nodes = new vis.DataSet([{"id":-164443025,"label":"-164443025"},{"id":25849013,"label":"25849013"},{"id":220951746,"label":"220951746"},{"id":353088720,"label":"353088720"},{"id":44238102,"label":"44238102"},{"id":151767338,"label":"151767338"},{"id":95726974,"label":"95726974"},{"id":180650495,"label":"180650495"},{"id":313234058,"label":"313234058"},{"id":140574359,"label":"140574359"},{"id":190654130,"label":"190654130"},{"id":329457353,"label":"329457353"},{"id":487439108,"label":"487439108"},{"id":143305524,"label":"143305524"},{"id":159017846,"label":"159017846"},{"id":248368078,"label":"248368078"},{"id":153455603,"label":"153455603"},{"id":230678627,"label":"230678627"},{"id":410178563,"label":"410178563"},{"id":64914441,"label":"64914441"},{"id":315411751,"label":"315411751"},{"id":50603384,"label":"50603384"},{"id":148079096,"label":"148079096"},{"id":1303327,"label":"1303327"},{"id":386931565,"label":"386931565"},{"id":17205471,"label":"17205471"},{"id":158726382,"label":"158726382"},{"id":388003090,"label":"388003090"},{"id":12245267,"label":"12245267"},{"id":7439697,"label":"7439697"},{"id":21612935,"label":"21612935"},{"id":29866502,"label":"29866502"},{"id":83272479,"label":"83272479"},{"id":89432987,"label":"89432987"},{"id":109186035,"label":"109186035"},{"id":51595591,"label":"51595591"},{"id":142368076,"label":"142368076"},{"id":125531471,"label":"125531471"},{"id":256881634,"label":"256881634"},{"id":69415295,"label":"69415295"},{"id":333052348,"label":"333052348"},{"id":96802265,"label":"96802265"},{"id":2942776,"label":"2942776"},{"id":291951611,"label":"291951611"},{"id":183503340,"label":"183503340"},{"id":495735477,"label":"495735477"},{"id":4785715,"label":"4785715"},{"id":124620391,"label":"124620391"},{"id":160073342,"label":"160073342"},{"id":114418352,"label":"114418352"},{"id":228160131,"label":"228160131"},{"id":349224610,"label":"349224610"},{"id":440191854,"label":"440191854"},{"id":41958066,"label":"41958066"},{"id":159397601,"label":"159397601"},{"id":70853357,"label":"70853357"},{"id":47617775,"label":"47617775"},{"id":95985542,"label":"95985542"},{"id":371761953,"label":"371761953"},{"id":33952610,"label":"33952610"},{"id":90556314,"label":"90556314"},{"id":182390709,"label":"182390709"},{"id":62085081,"label":"62085081"},{"id":365115365,"label":"365115365"},{"id":27118589,"label":"27118589"},{"id":135569407,"label":"135569407"},{"id":105082976,"label":"105082976"}]);
      // // create an array with edges
      // let edges = new vis.DataSet([{"from":-164443025,"to":25849013,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":220951746,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":353088720,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":44238102,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":151767338,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":95726974,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":180650495,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":313234058,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":140574359,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":190654130,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":329457353,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":487439108,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":143305524,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":159017846,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":248368078,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":153455603,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":230678627,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":410178563,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":-164443025,"to":64914441,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":353088720,"to":315411751,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":353088720,"to":50603384,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":353088720,"to":148079096,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":353088720,"to":1303327,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":353088720,"to":386931565,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":353088720,"to":230678627,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":12245267,"to":7439697,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":12245267,"to":21612935,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":12245267,"to":487439108,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":12245267,"to":410178563,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":315411751,"to":17205471,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":315411751,"to":21612935,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":315411751,"to":148079096,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":315411751,"to":29866502,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":315411751,"to":487439108,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":315411751,"to":83272479,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":315411751,"to":89432987,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":315411751,"to":109186035,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":125531471,"to":256881634,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":21612935,"to":487439108,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":21612935,"to":410178563,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":96802265,"to":2942776,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":96802265,"to":291951611,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":183503340,"to":158726382,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":180650495,"to":495735477,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":180650495,"to":487439108,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":180650495,"to":410178563,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":160073342,"to":114418352,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":349224610,"to":125531471,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":114418352,"to":440191854,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":190654130,"to":353088720,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":495735477,"to":487439108,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":487439108,"to":69415295,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":487439108,"to":159397601,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":487439108,"to":95985542,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":1303327,"to":148079096,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":143305524,"to":41958066,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":62085081,"to":440191854,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":109186035,"to":12245267,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":109186035,"to":21612935,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":109186035,"to":487439108,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":109186035,"to":410178563,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":153455603,"to":96802265,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":153455603,"to":183503340,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":27118589,"to":142368076,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":27118589,"to":440191854,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":410178563,"to":388003090,"arrows":{"to":{"enabled":true,"type":"arrow"}}},{"from":410178563,"to":33952610,"arrows":{"to":{"enabled":true,"type":"arrow"}}}]);
      // create a network
      const container = document.getElementById('graph');
      const data = this.data;
      const options = {
        interaction: {
          navigationButtons: true,
          keyboard: true
        }
      };
      const network = new vis.Network(container, data, options);
      network.once("stabilizationIterationsDone", () => {
        setTimeout(() => {
          this.renderIsReady=true;
          this.$emit('render-is-ready');
        }, 1500)
      });
    }
  }
</script>


<style>
    div.vis-network div.vis-navigation div.vis-button {
        transition: .5s;
        width:34px;
        height:34px;
        -moz-border-radius: 17px;
        border-radius: 17px;
        position:absolute;
        opacity: .1;
        display:inline-block;
        /*background-color: red;*/
        background-position: 2px 2px;
        background-repeat:no-repeat;
        cursor: pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    div.vis-network div.vis-navigation div.vis-button:hover {
        opacity: .8;
        /*filter: invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%);*/
    }


    /*div.vis-network div.vis-navigation div.vis-button:hover {*/
    /*    box-shadow: 0 0 3px 3px rgba(56, 207, 21, 0.30);*/
    /*}*/

    /*div.vis-network div.vis-navigation div.vis-button:active {*/
    /*    box-shadow: 0 0 1px 3px rgba(56, 207, 21, 0.95);*/
    /*}*/

    div.vis-network div.vis-navigation div.vis-button.vis-up {
        background-image: url("../assets/img/icons/chevron-top.svg");
        background-position-y: -3px;
        bottom:49px;
        left:55px;
    }
    div.vis-network div.vis-navigation div.vis-button.vis-down {
        background-image: url("../assets/img/icons/chevron-down.svg");
        bottom:10px;
        left:55px;
    }
    div.vis-network div.vis-navigation div.vis-button.vis-left {
        background-image: url("../assets/img/icons/chevron-left.svg");
        background-position-y: center;
        background-position-x: 8px;
        bottom:30px;
        left:31px;
    }
    div.vis-network div.vis-navigation div.vis-button.vis-right {
        background-image: url("../assets/img/icons/chevron-right.svg");
        background-position-y: center;
        background-position-x: 5px;
        bottom:30px;
        left:78px;
    }
    div.vis-network div.vis-navigation div.vis-button.vis-zoomIn {
        background-image: url("../assets/img/icons/zoom.svg");
        bottom:50px;
        right:15px;
    }
    div.vis-network div.vis-navigation div.vis-button.vis-zoomOut {
        background-image: url("../assets/img/icons/unzoom.svg");
        bottom:10px;
        right:15px;
    }
    div.vis-network div.vis-navigation div.vis-button.vis-zoomExtends {
        background-image: url("../assets/img/icons/arrows-alt.svg");
        background-position: center;
        width: 25px;
        height: 25px;
        bottom: 35px;
        left: 59px;
    }
</style>
<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    #graph {
        border: none;
        outline: none;
    }

    .vis-network {
        border: none !important;
        outline: none !important;
    }

    #graph:hover {
        outline: 1px solid #5CA5D4 !important;
        /*border: 1px solid #5CA5D4 !important;*/
    }
</style>
